import { render, staticRenderFns } from "./site-setup-main.component.vue?vue&type=template&id=d6094540&scoped=true"
import script from "./site-setup-main.component.ts?vue&type=script&lang=ts&external"
export * from "./site-setup-main.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-setup-main.component.vue?vue&type=style&index=0&id=d6094540&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6094540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6094540')) {
      api.createRecord('d6094540', component.options)
    } else {
      api.reload('d6094540', component.options)
    }
    module.hot.accept("./site-setup-main.component.vue?vue&type=template&id=d6094540&scoped=true", function () {
      api.rerender('d6094540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-setup/site-setup-main/site-setup-main.component.vue"
export default component.exports